import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import MessageBox from 'src/components/Compliance/MessageBox';
import BadgeImg from '../../assets/images/GreenStairs.png';
import Logomark from '../../assets/images/Logomark.png';
import RedExclamationMark from '../../assets/images/RedExclamationMark.png';

const NoBuildingLocated = () => {



  return (
    <ConfirmationWithBackButton
      icon={RedExclamationMark}
      title="Sorry, your building is not part of our network"
      subtitle="Please contact your Property Manager to provide them with a copy of your insurance policy directly. If you have any questions or concerns, please reach out to us at RI@TheGuarantors.com."
      image={BadgeImg}
      goBackLink="/compliance/welcome"
      message=
        <MessageBox
          image={Logomark}
          title="Still have a question?"
        />
    />
  );
};

export default NoBuildingLocated;
